import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import * as model from '../../../models';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { Store } from "@ngrx/store";
import { Subscription } from 'rxjs/Rx';
import * as moment from 'moment';
import { EventApi } from "../../../services/webservice";
import { AppState } from "../../../reducers";
import { EventBasicData } from "../../../models";

@Component({
	selector: 'one-time-events',
	templateUrl: "./one-time-events.component.html",
	styleUrls: ["./one-time-events.component.scss"],
})

export class OneTimeEventsComponent implements OnInit {

	oneTimeEvents: EventBasicData[];

	private subscription: Subscription;

	constructor(
		private store: Store<AppState>,
		private eventApi: EventApi
	) {}

	ngOnInit() {
		this.subscription = this.store.select("eventServerState", "event", "currentEvent").subscribe((event: model.Event) => {
			if (!event) return;

			this.eventApi.getOneTimeEvents(event.storageId).subscribe(
				oneTimeEvents => this.oneTimeEvents = oneTimeEvents.sort((oneTimeEventA, oneTimeEventB) =>
				moment(oneTimeEventA.begin, "YYYY-MM-DD'T'HH:mm:ss").diff(moment(oneTimeEventB.begin, "YYYY-MM-DD'T'HH:mm:ss")))
			)}
		)
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

}



// WEBPACK FOOTER //
// ./src/app/components/event-components/one-time-events/one-time-events.component.ts